var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card m-5 p-5"},[_vm._v(_vm._s(_vm.$t('Coming soon...')))])])}
var staticRenderFns = []

export { render, staticRenderFns }